import { Tooltip, Text } from '@frontend/legacy-components';

import {
  temporarilySimplifiedColorHex,
  tooComplexColorHex,
} from '../constants';
import { ViewProblemIcon } from './Icons';
import { temporarilySimplifiedLanguage, tooComplexLanguage } from './Language';

export const TemporarilySimplifiedIndicatorForBody = ({ ...props }) => (
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  <Tooltip
    placement="right"
    variant="expanded"
    label={
      <>
        <Text fontWeight="bold" color="feature.onInteraction">
          {temporarilySimplifiedLanguage.headlineForBody}
        </Text>
        <Text color="feature.onInteraction" variant="expanded">
          {temporarilySimplifiedLanguage.descriptionForBody}
        </Text>
      </>
    }
  >
    <ViewProblemIcon color={temporarilySimplifiedColorHex} {...props} />
  </Tooltip>
);

export const TemporarilySimplifiedIndicatorForPart = ({ ...props }) => (
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  <Tooltip
    placement="right"
    variant="expanded"
    label={
      <>
        <Text fontWeight="bold" color="feature.onInteraction">
          {temporarilySimplifiedLanguage.headlineForPart}
        </Text>
        <Text color="feature.onInteraction" variant="expanded">
          {temporarilySimplifiedLanguage.descriptionForPart}
        </Text>
      </>
    }
  >
    <ViewProblemIcon color={temporarilySimplifiedColorHex} {...props} />
  </Tooltip>
);

export const TooComplexIndicatorForBody = ({ ...props }) => (
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  <Tooltip
    placement="right"
    variant="expanded"
    label={
      <>
        <Text fontWeight="bold" color="feature.onInteraction">
          {tooComplexLanguage.headlineForBody}
        </Text>
        <Text color="feature.onInteraction" variant="expanded">
          {tooComplexLanguage.descriptionForBody}
        </Text>
      </>
    }
  >
    <ViewProblemIcon color={tooComplexColorHex} {...props} />
  </Tooltip>
);

export const TooComplexIndicatorForPart = ({ ...props }) => (
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  <Tooltip
    placement="right"
    variant="expanded"
    label={
      <>
        <Text fontWeight="bold" color="feature.onInteraction">
          {tooComplexLanguage.headlineForPart}
        </Text>
        <Text color="feature.onInteraction" variant="expanded">
          {tooComplexLanguage.descriptionForPart}
        </Text>
      </>
    }
  >
    <ViewProblemIcon color={tooComplexColorHex} {...props} />
  </Tooltip>
);
